import { cn } from '@utils/cn';
import { type ComponentProps } from 'react';

const TimeLineBody = ({
  className,
  children,
  ...props
}: ComponentProps<'div'>) => {
  return (
    <div
      className={cn('mt-3 text-xs text-muted-foreground', className)}
      {...props}
    >
      {children}
    </div>
  );
};

export { TimeLineBody };
